import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import { smoothScrollTop } from "utils";
import { Navigation, UserNavigation, LoginNavigation } from "utils/constant";

const AllNavigation = {
  ...Navigation,
  ...UserNavigation,
  ...LoginNavigation,
};

const useNavigation = (props) => {
  const location = useLocation();
  const [tab, setTab] = useState("");

  const getResultNav = (navs, value) => {
    const resArr = _.filter(navs, nav => nav.value === value);
    return resArr?.length ? resArr[0] : {};
  }

  useEffect(() => {
    const { pathname } = location;
    smoothScrollTop();
    document.title = props?.title || "荣晶科技";
    if (pathname === "/") {
      const { home } = Navigation;
      setTab(home.value);
      // window.selectedTab = home.value;
    } else {
      const str = pathname.substring(1);
      const pathnames = _.split(str, "/");
      let navs = _.values(AllNavigation);
      let pre = "";
      let res = {};
      _.forEach(pathnames, path => {
        const value = pre + path;
        res = getResultNav(navs, value);
        if (res.list?.length) {
          navs = [ ...res.list ];
          pre = `${res.value}-`;
        }
      });
      const currTab = res.value ? res.value : _.join(pathnames, "-");
      setTab(currTab);
      // window.selectedTab = res.value;
    }
  }, [location, props?.title]);

  return tab;
}
useNavigation.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default useNavigation;
